import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* depositToOwnerSavings(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_REQUEST
    })

    let requestPayload: any = {};

    if (action.payload?.amount) {
      requestPayload.amount = action.payload?.amount;
    }

    if (action.payload?.chargeId) {
      requestPayload.chargeId = action.payload?.chargeId;
    }

     const res = yield call(Http.post, `savings/${action.payload?.ownerId}/deposit`, {
       ...requestPayload
     });

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_SUCCESS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-deposit-to-savings-done-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchDepositToOwnerSavings() {
  yield takeEvery(Constants.GLOBAL_DEPOSIT_TO_OWNER_SAVINGS_START, depositToOwnerSavings);
}
